(function () {
  'use strict';

  class GiftGuideAgeFilter {
    constructor(container) {
      this.container   = container;
      this.sectionId   = container.dataset.sectionId;
      this.filterBar   = container.querySelector('.gg-filter-bar');
      this.tabs        = container.querySelectorAll('.gg-tab');
      this.sections    = container.querySelectorAll('.gg-age-section');
      this._scrollLock = false;

      if (!this.filterBar || !this.tabs.length || !this.sections.length) return;

      this._bindTabs();
    }

    _bindTabs() {
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', (e) => {
          e.preventDefault();

          const targetId = tab.dataset.target;
          const target   = document.getElementById(targetId);

          if (!target) return;

          // Make the clicked tab active
          this._setActiveTab(targetId);

          // Scroll to the corresponding section
          const top = target.getBoundingClientRect().top + window.scrollY;

          window.scrollTo({
            top,
            behavior: 'smooth'
          });

          // Highlight the section
          this._highlight(target);
        });
      });
    }

    _setActiveTab(targetId) {
      this.tabs.forEach((tab) => {
        const isActive = tab.dataset.target === targetId;

        tab.classList.toggle('is-active', isActive);
        tab.setAttribute(
          'aria-selected',
          isActive ? 'true' : 'false'
        );
      });
    }

    _highlight(sectionEl) {
      this.sections.forEach((s) => {
        s.classList.remove('js-gg-highlight');
      });

      void sectionEl.offsetWidth;

      sectionEl.classList.add('js-gg-highlight');

      sectionEl.addEventListener(
        'animationend',
        () => {
          sectionEl.classList.remove('js-gg-highlight');
        },
        { once: true }
      );
    }

    destroy() {
      // No IntersectionObserver to destroy anymore
    }
  }

  function initAll() {
    document
      .querySelectorAll('[data-section-type="gift-guide-age-filter"]')
      .forEach((el) => {
        if (!el._ggInstance) {
          el._ggInstance = new GiftGuideAgeFilter(el);
        }
      });
  }

  document.addEventListener('shopify:section:load', (e) => {
    const container = e.target.querySelector(
      '[data-section-type="gift-guide-age-filter"]'
    );

    if (container) {
      if (container._ggInstance) {
        container._ggInstance.destroy();
      }

      container._ggInstance = new GiftGuideAgeFilter(container);
    }
  });

  document.addEventListener('shopify:section:unload', (e) => {
    const container = e.target.querySelector(
      '[data-section-type="gift-guide-age-filter"]'
    );

    if (container && container._ggInstance) {
      container._ggInstance.destroy();
      delete container._ggInstance;
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
